<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.33313 10.3701C12.1968 10.3701 14.5183 8.04864 14.5183 5.18494C14.5183 2.32124 12.1968 -0.000244141 
    9.33313 -0.000244141C6.46944 -0.000244141 4.14795 2.32124 4.14795 5.18494C4.14795 8.04864 6.46944 10.3701 9.33313 10.3701Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M13.3333 21.7774V17.333V14.333C13.3333 13.7807 13.7806 13.333 14.3329 13.333C15.1214 13.333 16.5168 
    13.333 19.5556 13.333L20.4444 13.7774C19.5556 13.333 19.5556 13.333 20.4444 13.7774C20.4444 13.333 20.4502 
    13.5925 20.4582 13.333C19.7577 12.7 19.1099 12.4441 17.4895 12.4441H6.72673C3.01223 12.4441 0 14.766 0 
    17.6293V20.9996C0 21.429 0.452036 21.7774 1.00901 21.7774H9.66496H13.3333Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M22.9135 15.3083V22.9133H15.3086V15.3083H22.9135ZM22.9135 14.2219H15.3086C14.7111 14.2219 14.2222 
    14.7108 14.2222 15.3083V22.9133C14.2222 23.5108 14.7111 23.9997 15.3086 23.9997H22.9135C23.5111 23.9997 
    23.9999 23.5108 23.9999 22.9133V15.3083C23.9999 14.7108 23.5111 14.2219 22.9135 14.2219Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M20.1975 21.8269H16.395V20.7405H20.1975V21.8269ZM21.8271 19.654H16.395V18.5676H21.8271V19.654ZM21.8271 
    17.4812H16.395V16.3948H21.8271V17.4812Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
